import * as React from 'react';
import { SVGProps } from 'react';

const IconLithologyStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 11H5v2h2v-2ZM8 14h2v2H8v-2ZM13 17h-2v2h2v-2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm16 2H4v4h16V4ZM4 20V10h16v10H4Z"
    />
    <path d="M11 11h2v2h-2v-2ZM14 14h2v2h-2v-2ZM17 17h2v2h-2v-2ZM17 11h2v2h-2v-2ZM5 17h2v2H5v-2Z" />
  </svg>
);
export default IconLithologyStrokedSizeM;
